import type React from 'react';
import SvgIcon from './SvgIcon';

const Trashcan: React.FC = () => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="Trashcan">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 8H19.4258L18.4971 20.0771C18.4568 20.5979 18.0224 21 17.5 21H6.5C5.97761 21 5.54322 20.5979 5.50293 20.0771L4.57422 8H3V6H21V8ZM7.42578 19H16.5742L17.4199 8H6.58008L7.42578 19Z"
        fill="#7B61FF" />
      <path d="M12 2C13.1728 2 14.075 2.29432 14.6973 2.60547C15.0067 2.76017 15.2447 2.91837 15.4121 3.04395C15.4957 3.10665 15.5624 3.16129 15.6113 3.2041C15.6356 3.22536 15.656 3.24395 15.6719 3.25879C15.6798 3.26622 15.6866 3.27368 15.6924 3.2793C15.6953 3.28211 15.6988 3.28477 15.7012 3.28711L15.7041 3.29004L15.7061 3.29102L14.2939 4.70801L14.3047 4.71875C14.3047 4.71875 14.3012 4.71544 14.2949 4.70996C14.2814 4.69814 14.254 4.6744 14.2129 4.64355C14.1304 4.58165 13.9932 4.48978 13.8027 4.39453C13.425 4.20567 12.8272 4 12 4C11.1728 4 10.575 4.20567 10.1973 4.39453C10.0068 4.48978 9.86965 4.58165 9.78711 4.64355C9.746 4.6744 9.71859 4.69814 9.70508 4.70996C9.69882 4.71544 9.69531 4.71875 9.69531 4.71875L9.70605 4.70801L8.29395 3.29199L8.29883 3.28711C8.3012 3.28477 8.30471 3.28211 8.30762 3.2793C8.31342 3.27368 8.3202 3.26622 8.32812 3.25879C8.34396 3.24395 8.36438 3.22536 8.38867 3.2041C8.43761 3.16129 8.50429 3.10665 8.58789 3.04395C8.75534 2.91837 8.99332 2.76017 9.30273 2.60547C9.92502 2.29432 10.8272 2 12 2Z" fill="#7B61FF" />
    </g>
  </SvgIcon>
);

export default Trashcan;
